import Pessoa from "model/administracao/cadastro/Pessoa";

export default class PessoaEndereco {
    id: number | null = null;
    pessoa: Pessoa | null = null;
    principal = false;
    ativo = true;
    tipoEndereco: string = "FISCAL";
    logradouro = "";
    numeroEndereco: string | null = null;
    complemento: string | null = null;
    bairro = "";
    municipio: string | null = null;
    codigoMunicipioIbge: string | null = null;
    uf = "";
    cep: string | null = null;
    telefone: string | null = null;
    codigoPaisBacen: string | null = "1058";
    pais: string | null = "BRASIL";
}
